<template>
  <el-dialog
    :title="title"
    v-model="visible"
    width="700px"
    draggable
    @closed="onClosed"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="140px">
      <el-form-item label="开启短信？">
        <el-switch
          v-model="form.isSmsReport"
          :active-value="true"
          :inactive-value="false"
        ></el-switch>
      </el-form-item>
      <el-form-item label="负责人">
        <choose-consumer
          :list="consumerList"
          :companyId="1"
          @success="onFzrChange"
          :is-show="false"
        ></choose-consumer>
      </el-form-item>
      <el-form-item label="">
        <div class="draggable_row" v-for="item in chooseList" :key="item.id">
          <div>{{ item.name }}{{ item.mobile }}</div>
          <div style="margin-left: 20px">
            <el-checkbox v-model="item.isReceiveSms" :label="true"
              >接收短信通知</el-checkbox
            >
          </div>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="visible = false" :disabled="saving">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="saving"
        >确定</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import ChooseConsumer from "@/views/component/choose_consumer.vue";
// import Draggable from "vuedraggable";

export default {
  components: {
    ChooseConsumer,
    // Draggable,
  },
  data() {
    return {
      saving: false,
      visible: false,
      title: "",
      form: {},
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      consumerList: [], //已经存在的负责人
      chooseList: [], //已选择的
    };
  },
  props: {
    item: Object,
  },
  emits: ["closed", "success"],
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.title = `设置【${this.item.name}】负责人`;
          this.form = {
            id: this.item.id,
            isSmsReport: this.item.isSmsReport,
            // consumerIds: [],
          };
          if (this.item.zhuanyuanList) {
            this.consumerList = [];
            this.chooseList = [];
            this.item.zhuanyuanList.forEach((x) => {
              this.consumerList.push({
                id: x.consumerId,
                name: x.consumerName,
                mobile: x.consumerMobile,
                isReceiveSms: x.isReceiveSms,
              });
              this.chooseList.push({
                id: x.consumerId,
                name: x.consumerName,
                mobile: x.consumerMobile,
                isReceiveSms: x.isReceiveSms,
              });
            });
          }
          this.visible = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     *
     */
    onClosed() {
      this.$emit("closed");
    },

    /**
     * 负责人选择更改
     */
    onFzrChange(list) {
      this.chooseList = list;
      // this.form.consumerIds = list.map((x) => x.id);
    },

    /**
     *
     */
    onSubmit() {
      this.form.zhuanyuanList = this.chooseList.map((m) => {
        return {
          ConsumerId: m.id,
          isReceiveSms: m.isReceiveSms,
        };
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true;
          this.$http
            .post("admin/v1/dept/set_zy", this.form)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(res.msg);
                this.$emit("success");
                this.visible = false;
              }
            })
            .finally(() => (this.saving = false));
        }
      });
    },
  },
};
</script>

<style scoped>
.draggable_row {
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--el-border-color);
  cursor: pointer;
  width: 100%;
}
</style>
